import React from 'react'
import { memo } from 'react'
import PropTypes from 'prop-types'
import {
  IconBracelet,
  IconDiamond,
  IconEarring,
  IconNecklace,
  IconRectangle,
  IconOval,
  IconWatchStrap,
  IconMensWatch,
  IconRing,
  IconLeather,
  IconOther,
  IconPendant,
  IconPins,
  IconSet,
  IconNeutral,
  IconGatorSkin,
  IconTonneau,
  IconSquare,
  IconRound,
  IconLeatherStrap,
  IconMetalBand,
  IconSterlingSilver,
} from '../components/products/IconsProductPreloader'
import {
  IconCufflinks,
  IconGlasses,
  IconMulti,
  IconPen,
  IconRubberStrap,
  IconSkeleton,
} from '../components/Icons'

const FilterIconsComponent = ({ type, facet }) => {
  const IconColor = ({ color }) => <div className={`w-8 h-8 border border-gray-400 ` + color}></div>
  const MetalColor = ({ from, via, to }) => (
    <div className={`w-8 h-8 border border-gray-400 bg-gradient-to-tr ` + from + via + to}></div>
  )

  switch (type) {
    //Icon Images
    case 'Leather Strap': {
      return <IconLeatherStrap className="w-8 h-8 fill-current" />
    }
    case 'Metal Bracelet': {
      return <IconMetalBand className="w-8 h-8 fill-current" />
    }
    case 'Rubber Strap': {
      return <IconRubberStrap className="w-8 h-8 fill-current " flashing={false} />
    }

    //color definitions
    case 'Blue': {
      return <IconColor color="bg-blue-500" />
    }

    case 'Brown': {
      return <IconColor color="bg-[#964b00]" />
    }
    case 'Green': {
      return <IconColor color="bg-[#069e4b]" />
    }
    case 'Tan': {
      return <IconColor color="bg-[tan]" />
    }
    case 'White': {
      return <IconColor color="bg-white" />
    }
    case 'Teal': {
      return <IconColor color="bg-teal-400" />
    }
    case 'Red': {
      return <IconColor color="bg-red-500" />
    }
    case 'Gray': {
      return <IconColor color="bg-gray-400" />
    }
    case 'Rubber': {
      return <IconColor color="bg-neutral-800" />
    }
    case 'Orange': {
      return <IconColor color="bg-orange-400" />
    }
    case 'Pink': {
      return <IconColor color="bg-pink-400" />
    }
    case 'Purple': {
      return <IconColor color="bg-purple-400" />
    }
    case 'Yellow': {
      return <IconColor color="bg-yellow-400" />
    }
    case 'Black': {
      return <IconColor color="bg-black" />
    }
    case 'Burgundy': {
      return <IconColor color="bg-red-800" />
    }

    case 'Off-White': {
      return <IconColor color="bg-[#f8f8f8]" />
    }
    // case 'Silver': {
    //   return <IconColor color="bg-gray-300" />
    // }
    // case 'Gold': {
    //   return <IconColor color="bg-yellow-500" />
    // }
    case 'Champagne': {
      return <IconColor color="bg-[#f7e7ce]" />
    }
    // TODO: Add new icon
    case 'Skeleton': {
      return <IconSkeleton className="w-8 h-8 border border-gray-400 text-white bg-slate-500" />
    }
    case 'Beige': {
      return <IconColor color="bg-[#f5f5dc]" />
    }
    // case 'Bronze': {
    //   return <IconColor color="bg-[#cd7f32]" />
    // }
    case 'Multi-Color': {
      return <IconMulti className="w-8 h-8 border border-gray-400 " />
    }
    case 'Navy': {
      return <IconColor color="bg-blue-800" />
    }

    case 'Leather': {
      return <IconLeather className="w-8 text-[#f1dbc6] bg-[#b07a47] h-8 border border-gray-400 " />
    }

    case 'Alligator':
    case 'Lizard':
    case 'Crocodile': {
      return (
        <IconGatorSkin className="w-8 bg-green-700 text-green-200 h-8 border border-gray-400 " />
      )
    }

    case 'N/A':
    case 'null': {
      return <IconNeutral />
    }

    //Metal Definitions
    case 'Brass':
    case '14K':
    case '14k':
    case '10K':
    case 'Gold':
    case '18k':
    case 'Gold Fill':
    case 'Yellow Gold':
    case '18k Yellow Gold': {
      return <MetalColor from="from-yellow-100 " via="via-[#e4cf7e] " to="to-white " />
    }
    case 'PVD': {
      return <MetalColor from="from-cyan-700 " via="via-gray-800 " to="to-black " />
    }
    case 'Ceramic': {
      return <MetalColor from="from-gray-400 " via="via-gray-800 " to="to-black " />
    }
    case 'White Gold':
    case '14k White Gold': {
      return <MetalColor from="from-slate-100 " via="via-gray-300 " to="to-white " />
    }
    case 'Pink Gold':
    case 'Rose Gold':
    case 'Everose Gold':
    case '18k rose gold':
    case '14k rose gold':
    case '18k Pink Gold': {
      return <MetalColor from="from-[#ffd4bd] " via="via-[#f8a87e] " to="to-white " />
    }
    case 'Bronze': {
      return <MetalColor from="from-[#ce8946] " via="via-[#db6c2b] " to="to-[#fca956] " />
    }
    case 'Sterling Silver':
    case 'Tantalum':
    case 'Tungsten':
    case 'Steel':
    case 'Stainless Steel':
    case 'Silver': {
      return facet === 'item_type' ? (
        <IconSterlingSilver className="w-10 h-10 fill-current " flashing={false} />
      ) : (
        <MetalColor from="from-gray-100 " via="via-stone-300 " to="to-white " />
      )
    }
    case 'Titanium': {
      return <MetalColor from="from-slate-100 " via="via-slate-300 " to="to-white " />
    }
    case 'Aluminum':
    case 'Nickel':
    case 'Platinum':
    case 'Palladium': {
      return <MetalColor from="from-zinc-100 " via="via-zinc-300 " to="to-white " />
    }

    //Stone Colors
    case 'Kunzite':
    case 'Diamond': {
      return <MetalColor from="from-cyan-100 " via="via-white " to="to-white " />
    }
    case 'Pearl': {
      return <MetalColor from="from-amber-100 " via="via-white " to="to-white " />
    }
    case 'Sapphire': {
      return <MetalColor from="from-blue-900 " via="via-blue-900 " to="to-blue-400 " />
    }
    case 'Tanzanite': {
      return <MetalColor from="from-purple-700 " via="via-blue-700 " to="to-blue-400 " />
    }
    case 'Emerald': {
      return <MetalColor from="from-green-800 " via="via-green-700 " to="to-green-400 " />
    }
    case 'Malachite': {
      return <MetalColor from="from-green-700 " via="via-green-900 " to="to-yellow-500 " />
    }
    case 'Ruby': {
      return <MetalColor from="from-red-800 " via="via-red-700 " to="to-red-400 " />
    }
    case 'Topaz':
    case 'Opal': {
      return <MetalColor from="from-orange-300 " via="via-cyan-500 " to="to-cyan-200 " />
    }
    case 'Tourmaline': {
      return <MetalColor from="from-green-500 " via="via-pink-300 " to="to-pink-100 " />
    }
    case 'Aquamarine': {
      return <MetalColor from="from-cyan-500 " via="via-cyan-300 " to="to-cyan-100 " />
    }
    case 'No Stone': {
      return <IconNeutral className="w-8 h-8 border border-gray-400" />
    }
    case 'Amethyst': {
      return <MetalColor from="from-purple-800 " via="via-purple-600 " to="to-purple-100 " />
    }
    case 'Onix': {
      return <MetalColor from="from-black " via="via-black " to="to-gray-400 " />
    }
    case 'Citrine': {
      return <MetalColor from="from-orange-400 " via="via-orange-500 " to="to-yellow-200 " />
    }
    case 'Turquoise': {
      return <MetalColor from="from-cyan-400 " via="via-teal-500 " to="to-cyan-200 " />
    }
    case 'Moonstone':
    case 'Mother of Pearl': {
      return <MetalColor from="from-cyan-100 " via="via-gray-200 " to="to-white " />
    }

    //Two Tones
    case '14k & Stainless Steel':
    case '18k & Stainless Steel':
    case '18k White & Yellow Gold':
    case 'Two tone':
    case 'Two Tone':
    case '18k & steel': {
      return <div className="two-tone w-8 h-8 border border-gray-400 "></div>
    }

    //Case Shapes
    case 'Square': {
      return <IconSquare className="w-8 h-8 fill-current" />
    }
    case 'Rectangle': {
      return <IconRectangle className="w-8 h-8 fill-current" />
    }
    case 'Round': {
      return <IconRound className=" w-8 h-8 fill-current " />
    }
    case 'Oval': {
      return <IconOval className=" w-8 h-8 fill-current " />
    }
    case 'Tonneau': {
      return <IconTonneau className=" w-8 h-8 fill-current " />
    }

    //Jewelry Categories

    case 'Ring': {
      return <IconRing className="w-16 h-16 fill-current " flashing={false} />
    }
    case 'Bracelet': {
      return <IconBracelet className="w-16 h-16 fill-current " flashing={false} />
    }
    case 'Necklace': {
      return <IconNecklace className="w-16 h-16 fill-current " flashing={false} />
    }
    case 'Accessory': {
      return <IconOther className="w-16 h-16 p-2 fill-current " flashing={false} />
    }
    case 'Other': {
      return facet == 'jewelry_type' ? (
        <IconOther className="p-2 w-16 h-16 fill-current " flashing={false} />
      ) : (
        <IconOther className="w-8 h-8 fill-current " flashing={false} />
      )
    }
    case 'Cufflinks': {
      return <IconCufflinks className="p-2 w-16 h-16 fill-current " flashing={false} />
    }

    case 'Brooch':
    case 'Pin/Broach': {
      return <IconPins className="p-2 w-16 h-16 fill-current " flashing={false} />
    }

    case 'Pendant': {
      return <IconPendant className="p-2 w-16 h-16 fill-current " flashing={false} />
    }

    case 'Jewelry Set': {
      return <IconSet className="p-2 w-16 h-16 fill-current " flashing={false} />
    }

    case 'Glasses': {
      return <IconGlasses className="p-2 w-16 h-16 fill-current " flashing={false} />
    }

    case 'Pen/Pencil': {
      return <IconPen className="p-2 w-16 h-16 fill-current " flashing={false} />
    }

    case 'Earrings': {
      return <IconEarring className="w-16 h-16 fill-current " flashing={false} />
    }
    case 'Watch/bracelet': {
      return <IconWatchStrap className="w-16 h-16 fill-current " flashing={false} />
    }
    case 'Loose Diamond': {
      return <IconDiamond className="w-16 h-16 fill-current " flashing={false} />
    }

    // Item Type
    case 'Watch': {
      return <IconMensWatch className="w-10 h-10 fill-current " flashing={false} />
    }
    case 'Jewelry': {
      return <IconSet className="w-10 h-10 fill-current " flashing={false} />
    }
    case 'Pens': {
      return <IconPen className="w-10 h-10 fill-current " flashing={false} />
    }
    case 'Watch Bands': {
      return <IconLeatherStrap className="w-10 h-10 fill-current " flashing={false} />
    }

    default:
      if ((facet || '').indexOf('color') >= 0) return <IconNeutral />
      return <></>
  }
}

FilterIconsComponent.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
}

FilterIconsComponent.defaultProps = {
  type: null,
  className: null,
}

export const FilterIcons = memo(FilterIconsComponent)
